import { memo, type ReactNode } from 'react';
import { clsx } from 'clsx';
import { useTitle } from 'hoofd';
import { VStack, HStack } from '@hst-horizon/horizon-ui';
import useCurrentStore from '../../hooks/useCurrentStore';
import LanguageSelector from '../../../user/components/LanguageSelector';
import CompanyLogo from '../CompanyLogo';
import Container from '../Container';
import styles from './HeadlessPage.module.scss';

const HeadlessPage = memo(
    ({
        title,
        children,
        footer,
        stickyFooter,
    }: {
        title?: string;
        children: ReactNode;
        footer: ReactNode;
        stickyFooter?: boolean;
    }) => {
        const { companyName: storeTitle } = useCurrentStore();
        useTitle(`${title} - ${storeTitle}`);
        return (
            <div className={styles.container}>
                <VStack gap="small" expanded justify="spaceBetween">
                    <div>
                        <Container>
                            <VStack gap="small">
                                <HStack
                                    align="center"
                                    gap="small"
                                    justify="spaceBetween"
                                >
                                    <div className={styles.logo}>
                                        <CompanyLogo />
                                    </div>
                                    <LanguageSelector />
                                </HStack>
                                <div />

                                {children}
                            </VStack>
                        </Container>
                    </div>

                    {footer && (
                        <div
                            className={clsx(styles.footer, {
                                [styles.stickyFooter]: stickyFooter,
                            })}
                        >
                            {footer}
                        </div>
                    )}
                </VStack>
            </div>
        );
    }
);

export default HeadlessPage;
